import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { SitemapImportModal } from './SitemapImportModal';
import type { ProjectUrlHints } from '../lib/utils';
import { IndexerIcon } from './IndexerIcon';

export function SitemapUrlImport({
  projectId,
  project,
  limit,
  existingUrls,
  onImport,
}: {
  projectId: string;
  project: ProjectUrlHints;
  limit?: number;
  existingUrls: string[];
  onImport: (
    urls: string[],
    options?: { lastmods?: Record<string, string> },
  ) => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline-primary"
        size="sm"
        className="d-inline-flex align-items-center gap-1"
        onClick={() => setOpen(true)}
      >
        <IndexerIcon name="diagram-3" />
        درج از نقشه سایت
      </Button>
      <SitemapImportModal
        show={open}
        onClose={() => setOpen(false)}
        projectId={projectId}
        project={project}
        limit={limit}
        existingUrls={existingUrls}
        onImport={(selected, options) => {
          onImport(selected, options);
          setOpen(false);
        }}
      />
    </>
  );
}
